import {useContext, useEffect, useRef} from 'react'
import {useNavigate, useSearchParams} from "react-router-dom";
import authService from "../../../services/AuthService";
import showNotification from "../../../components/extras/showNotification";
import {useMst} from "../../../models";
import {useTranslation} from "react-i18next";
import {Configs} from '../../../models/Configs';
import {demoPages} from '../../../menu';
import {Base64} from "js-base64";
import companyService from "../../../services/CompanyService";
import config from '../../../config';
import ThemeContext from "../../../contexts/themeContext";

const AzureLoginCallback = () => {
    const { user, company } = useMst()
    const [searchParams,] = useSearchParams()
    const navigate = useNavigate()
    const { t } = useTranslation();
    const isCalledRef = useRef(false);
    const { mobileDesign } = useContext(ThemeContext);

    const azureLogin = async (code, state) => {
        let res = await authService.azureLogin({ code, registrationId: config.REGISTRATION_ID });
        const finalState = state ? decodeURIComponent(state) : state;
        
        // 인증 성공
        if (res?.result) {
            user.authMe().then(async () => {
                await Promise.all([
                    Configs.sendDevice(),
                    user.me.currentCompanyId
                    && company.selectCompany(
                        user.me.currentCompanyId, mobileDesign, finalState && !finalState.includes('requestId')
                    ),
                ]);

                if (user.me.id) {
                    if (finalState && finalState.includes('requestId')) {
                        const { state: approvalState, requestId } = JSON.parse(finalState);

                        try {
                            const resAppr = await companyService.approval({
                                id : requestId,
                                userId : user.me.id,
                                state : approvalState.replace(/CANCEL|PLAN/g, '')
                            });

                            // 로고 이미지 Base64 값
                            const logoResponse = await companyService.info({ id: company.id });
                            const logoBase64 = logoResponse.data.logoBase64;

                            // 결과 페이지로 보낼 파라미터를 암호화해서 세션에 담기
                            sessionStorage.setItem(
                                'approvalResult',
                                Base64.encode(
                                    JSON.stringify({
                                        state: approvalState,
                                        result: resAppr?.result,
                                        message: !resAppr?.result ? resAppr?.data?.message : "",
                                        logo: logoBase64
                                    })
                                )
                            );

                            window.location.href = `/vacation.request.approval.html`;
                        } catch(error) {
                            console.error('error', error);
                        }
                    }
                    else{
                        window.location.replace(!user.me.currentCompanyId ? '/change-company' : finalState || '/');
                    }
                }
            }).catch((e) => {
                showNotification(t('로그인'), t('로그인에 실패하였습니다.') + t('다시 확인해주세요') + '.', 'danger');
                navigate('/' + demoPages.login.path);
            });
        } 
        // 인증 실패
        else {
            showNotification(t('로그인'), t('인증에 실패하였습니다.'), 'danger');
            navigate('/' + demoPages.login.path)
        }
    }

    useEffect(() => {
        // 리렌더링 되더라도 1번만 실행되도록
        if (!isCalledRef.current) {
            isCalledRef.current = true;

            const code = searchParams.get('code'),
                  state = searchParams.get('state');
  
            if (code)
                azureLogin(code, state)
            else
                navigate('/')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams])
}

export default AzureLoginCallback
